import React from "react";
import { scrambleSentence } from "../../../helpers/stringHelpers";

import styles from "./ScrambledSentence.module.css"

const ScrambledSentence = ( { sentence } ) =>
{

    if (sentence)
    {
        return <h1 className={styles.root}>{scrambleSentence(sentence)}</h1>;
    }
    else 
    {
        return null;
    }
}

export default ScrambledSentence;   